import React, {useEffect, useRef }from 'react'
import { useDispatch  } from 'react-redux'
import styled from 'styled-components' 
import { useNavigate, useLocation } from 'react-router-dom'
import { addAc } from 'features/auth/authSlice'
import { addAcFunc } from 'funcs/ac'
import Audio from './audio/Audio'
import Videos from './video/Videos'
import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'; 
import useToggleDropdown from 'hooks/useToggleDropdown'
import { DotEle, DotsWrap } from 'components/dots/dots.styled';   
import { setViewUploadAudioModal } from 'features/audio/audioSlice'
import { setViewUploadVideoModal } from 'features/videos/videoSlice'
import { pBtn } from 'components/main.styled' 
import { Toaster } from 'react-hot-toast'
import { MdAdd } from "react-icons/md";
import Tooltip from '@mui/material/Tooltip';
import { FiImage } from "react-icons/fi"; 
import Images from './images/Images'
import { setViewImageUploadModal } from 'features/images/imagesSlice'
import { useTranslation } from 'react-i18next'

export default function MediaPage() {
    const { t } = useTranslation('media')

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    const view = new URLSearchParams(location.search).get('view') ? new URLSearchParams(location.search).get('view') : 'none'
    const ref1 = useRef(null)
    const [isDropped, setIsDropped] = useToggleDropdown(ref1)
    const handleDropDown = () => { setIsDropped.toggle(ref1) }

    const handleNavigate = (section) => { 
        localStorage.setItem('mediaView', section) 
        navigate(`?section=media&view=${section}`)
    }

    useEffect(() => {
        const dis = () => dispatch(addAc({
            type: 'videos', 
        }))
        addAcFunc('vd', dis)
    }, [])


    useEffect(() => {
        let currentView = localStorage.getItem('mediaView')
        if(!currentView){
            localStorage.setItem('mediaView', 'videos')
            navigate(`?section=media&view=videos`)
        }else{
            navigate(`?section=media&view=${currentView}`)
        }
    }, [])
        
    const handleUploadAudio = () => {
        dispatch(setViewUploadAudioModal(true))
        navigate(`?section=media&view=audio`)
    }

    const handleUploadVideo = () => {
        dispatch(setViewUploadVideoModal(true))
        navigate(`?section=media&view=videos`)
    }

    const handleUploadImage = () => {
        dispatch(setViewImageUploadModal(true))
        navigate(`?section=media&view=images`)
    }

    return (
        <MediaPageContainer> 
            <Toaster />
            <ButtonWrap>

                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px',  }}>
                    <MediaButton
                        active={view === 'videos' ? true : false}
                        onClick={() => handleNavigate('videos')}
                        >
                        <PlayCircleOutlineIcon />
                        <span>{t('tabs.videos')}</span>
                    </MediaButton>
                    <MediaButton
                        active={view === 'audio' ? true : false}
                        onClick={() => handleNavigate('audio')}
                        >
                        <GraphicEqIcon />
                        <span>{t('tabs.audio')}</span>
                    </MediaButton> 
                    <MediaButton
                        active={view === 'images' ? true : false}
                        onClick={() => handleNavigate('images')}
                        >
                        <FiImage size={20} />
                        <span>{t('tabs.images')}</span>
                    </MediaButton> 
                </div>
                <Tooltip title={t('addMedia')} placement="bottom">
                    <MediaMenu
                        ref={ref1}
                        onClick={handleDropDown}
                        >
                        <MdAdd />
                        {t('addMedia')}
                    </MediaMenu>
                </Tooltip>
                { 
                    isDropped && 
                    (
                        <DotsWrap 
                            top='30px'
                            right='0px'
                            >
                            <DotEle
                                onClick={handleUploadVideo}
                                >
                                <PlayCircleOutlineIcon style={{marginRight: '10px'}}/>
                                {t('uploadVideo')}
                            </DotEle>
                            <DotEle
                                onClick={handleUploadAudio}
                                >
                                <GraphicEqIcon style={{marginRight: '10px'}}/>
                                {t('uploadAudio')}
                            </DotEle>
                            <DotEle
                                onClick={handleUploadImage}
                                >
                                <FiImage  size={20} style={{marginRight: '10px'}}/>
                                {t('uploadImage')}
                            </DotEle>
                        </DotsWrap>
                    )
                } 
            </ButtonWrap> 
            {
                view === 'audio' ? <Audio /> :  
                view === 'videos' ? <Videos /> :
                view === 'images' ? <Images /> : 
                <div>{t('notFound')}</div>
            } 
        </MediaPageContainer>
    )
}

const MediaPageContainer = styled.div`
    height: 100%;
    padding: 10px;

    @media (max-width: 768px) {
        padding: 0px;
        padding-top: 10px;
    }

`
const MediaMenu = styled(pBtn)`
    background-color: white; 
    color: var(--lightThemeFontColor); 

    &:hover{
        transition: all 0.3s;
        background-color: #dfdfdf; 
    }

`
const ButtonWrap = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;  

    @media (max-width: 768px) {
        padding: 0px 5px; 
    }

`

const MediaButton = styled(pBtn)`
    pointer-events: ${props => props.active ? 'none' : 'auto'};
    background-color: ${props => props.active ? 'var(--themeColor)' : 'white'};
    color: ${props => props.active ? 'white' : 'var(--lightThemeFontColor);'};
    transition: background-color 0.3s;

    &:hover{
        background-color: #e1e1e1;
    }

`
